const SvgIcon = ({ size = '24', color = '#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={size}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    version="1.1"
    viewBox="0 0 24.003 24"
  >
    <path
      fill={color}
      stroke="none"
      strokeWidth="2.182"
      d="M12.001 0c-.692 0-1.384.217-1.964.652L1.309 7.198A3.28 3.28 0 0 0 0 9.817v10.91A3.29 3.29 0 0 0 3.273 24H20.73a3.29 3.29 0 0 0 3.273-3.273V9.817a3.29 3.29 0 0 0-1.304-2.615l-.004-.004L13.966.652A3.27 3.27 0 0 0 12.001 0m-.654 2.397a1.08 1.08 0 0 1 1.309 0l8.723 6.544c.28.213.441.536.441.876v10.91c0 .615-.475 1.091-1.09 1.091H3.272a1.075 1.075 0 0 1-1.09-1.091V9.817c0-.344.16-.667.436-.874z"
      color="#000"
    ></path>
    <path
      fill={color}
      stroke="none"
      strokeWidth="2.182"
      d="M1.677 8.896a1.09 1.09 0 0 0-1.506.335 1.09 1.09 0 0 0 .334 1.506l9.787 6.22.007.003a3.21 3.21 0 0 0 3.405 0l.006-.003 9.787-6.22a1.09 1.09 0 0 0 .335-1.506 1.09 1.09 0 0 0-1.507-.335l-9.78 6.216a1.02 1.02 0 0 1-1.087 0z"
      color="#000"
    ></path>
  </svg>
);

export default SvgIcon;
